import React, {
    useState,
    useEffect,
} from "react";

import axios from "axios";
import { useNavigate } from "react-router-dom";
import AdminLayout from "./AdminLayout";

const AdminTour = () => {
    const navigate = useNavigate();

    const [title, setTitle] =
        useState("");

    const [image, setImage] =
        useState(null);

    const [data, setData] =
        useState([]);

    const [editId, setEditId] =
        useState(null);

    /* FETCH DATA */
    const fetchData =
        async () => {
            try {
                const res =
                    await axios.get(
                        "https://stjosephweb.ilakshyaerp.in/api/tours"
                    );

                setData(
                    Array.isArray(
                        res.data
                    )
                        ? res.data
                        : []
                );
            } catch (error) {
                console.log(
                    error
                );
            }
        };

    useEffect(() => {
        fetchData();
    }, []);

    /* SUBMIT */
    const submit =
        async (e) => {
            e.preventDefault();

            if (!title) {
                alert(
                    "Enter room title"
                );
                return;
            }

            try {
                const formData =
                    new FormData();

                formData.append(
                    "title",
                    title
                );

                if (image) {
                    formData.append(
                        "image",
                        image
                    );
                }

                let res;

                if (editId) {
                    res =
                        await axios.put(
                            `https://stjosephweb.ilakshyaerp.in/api/tours/edit/${editId}`,
                            formData,
                            {
                                headers:
                                {
                                    "Content-Type":
                                        "multipart/form-data",
                                },
                            }
                        );
                } else {
                    if (!image) {
                        alert(
                            "Select image"
                        );
                        return;
                    }

                    res =
                        await axios.post(
                            "https://stjosephweb.ilakshyaerp.in/api/tours/add",
                            formData,
                            {
                                headers:
                                {
                                    "Content-Type":
                                        "multipart/form-data",
                                },
                            }
                        );
                }

                alert(
                    res.data.message
                );

                setTitle("");
                setImage(null);
                setEditId(null);

                document.getElementById(
                    "fileInput"
                ).value = "";

                fetchData();

            } catch (error) {
                console.log(error.response?.data || error);

                if (error.response?.data?.message) {
                    alert(error.response.data.message);
                } else {
                    alert("Operation Failed");
                }
            }
        };

    /* EDIT */
    // const handleEdit = (
    //     item
    // ) => {
    //     setTitle(
    //         item.title
    //     );

    //     setEditId(
    //         item.id
    //     );

    //     window.scrollTo({
    //         top: 0,
    //         behavior:
    //             "smooth",
    //     });
    // };

    /* DELETE */
    const handleDelete =
        async (id) => {
            try {
                const res =
                    await axios.delete(
                        `https://stjosephweb.ilakshyaerp.in/api/tours/delete/${id}`
                    );

                alert(
                    res.data.message
                );

                fetchData();

            } catch (error) {
                console.log(error.response?.data || error);

                if (error.response?.data?.message) {
                    alert(error.response.data.message);
                } else {
                    alert("Delete Failed");
                }
            }
        };

    return (
        <AdminLayout>
            <div className="notice-page">

                {/* FORM */}
                <div className="notice-card">
                    <h2>
                        {editId
                            ? "Edit Tour Room"
                            : "Add Tour Room"}
                    </h2>

                    <form
                        onSubmit={submit}
                    >
                        <input
                            type="text"
                            placeholder="Room Name"
                            value={title}
                            onChange={(e) =>
                                setTitle(
                                    e.target.value
                                )
                            }
                        />

                        <input
                            id="fileInput"
                            type="file"
                            accept=".jpg,.jpeg,.png,.webp"
                            onChange={(e) =>
                                setImage(
                                    e.target.files[0]
                                )
                            }
                        />

                        <p
                            style={{
                                fontSize:
                                    "14px",
                                color:
                                    "#e93e28",
                                marginBottom:
                                    "10px",
                            }}
                        >
                            Upload panorama /
                            room image
                        </p>

                        <button
                            type="submit"
                        >
                            {editId
                                ? "Update Room"
                                : "Add Room"}
                        </button>
                    </form>
                </div>

                {/* TABLE */}
                <div className="notice-table">

                    {/* TOP HEADER */}
                    <div
                        style={{
                            display:
                                "flex",
                            justifyContent:
                                "space-between",
                            alignItems:
                                "center",
                            marginBottom:
                                "20px",
                            flexWrap:
                                "wrap",
                            gap: "10px",
                        }}
                    >
                        <h2
                            style={{
                                margin: 0,
                            }}
                        >
                            All Rooms
                        </h2>

                        <button
                            onClick={() =>
                                navigate(
                                    "/admin/admin-hotspot"
                                )
                            }
                            style={{
                                background:
                                    "#1f3c6d",
                                color:
                                    "#fff",
                                border:
                                    "none",
                                padding:
                                    "10px 18px",
                                borderRadius:
                                    "6px",
                                cursor:
                                    "pointer",
                                fontWeight:
                                    "600",
                            }}
                        >
                            + Add Hotspot
                        </button>
                    </div>

                    <table>
                        <thead>
                            <tr>
                                <th>Image</th>
                                <th>Room Name</th>
                                <th>Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            {data.map(
                                (item) => (
                                    <tr
                                        key={
                                            item.id
                                        }
                                    >
                                        <td>
                                            <img
                                                src={`https://stjosephweb.ilakshyaerp.in/uploads/virtual-image/${item.image}`}
                                                width="120"
                                                height="70"
                                                style={{
                                                    objectFit:
                                                        "cover",
                                                    borderRadius:
                                                        "6px",
                                                }}
                                                alt="tour"
                                            />
                                        </td>

                                        <td>
                                            {
                                                item.title
                                            }
                                        </td>

                                        <td>

                                            {/* <button
                                                className="edit-btn"
                                                onClick={() => handleEdit(item)}
                                            >
                                                Edit
                                            </button> */}

                                            <button
                                                className="delete-btn"
                                                onClick={() =>
                                                    handleDelete(
                                                        item.id
                                                    )
                                                }
                                            >
                                                Delete
                                            </button>
                                        </td>
                                    </tr>
                                )
                            )}
                        </tbody>
                    </table>

                </div>

            </div>
        </AdminLayout>
    );
};

export default AdminTour;